@if (question.type !== questionType.Terminate) {
  <div
    [@swapQuestion]="question.id"
    class="survey-viewer__view-container question-view__container"
    [class.full-size]="fullSizeQuestions.includes(question.type)"
  >
    <empathy-viewer-template-card
      [noHeader]="!question.title"
      [fullSize]="fullSizeQuestions.includes(question.type)"
      [fitBox]="question.type === questionType.AIChat"
    >
      @if (question.stimulus?.length > 0 && !noStimulusQuestions.includes(question.type)) {
        <empathy-stimulus slot="stimulus" [stimulus]="question.stimulus" [singleImageSize]="'large'" [autoplay]="question.autoplayMediaInd"></empathy-stimulus>
      }

      <h1
        slot="title"
        [id]="question.id"
        class="question-view__title survey-viewer__html-content dynamic-title fw__600"
        [ngClass]="fullSizeQuestions.includes(question.type) ? 'full-size-title' : ''"
        [innerHTML]="question.title | content: question.id"
      ></h1>

      @if (question.description) {
        <span slot="subtitle" class="question-view__sub-title fs__xl fw__400 label" [innerHTML]="question.description | content: question.id"></span>
      }

      <empathy-error-container [question]="question" [questionCtrl]="questionCtrl"></empathy-error-container>

      <div slot="details" class="question-view__q-type-container" [class.full-size]="fullSizeQuestions.includes(question.type)">
        @switch (question.type) {
          @case (questionType.InfoPage) {
            <empathy-info-page-question-view [question]="question"></empathy-info-page-question-view>
          }
          @case (questionType.SingleChoice) {
            <empathy-single-choice-question-view [question]="question" [questionGrp]="questionCtrl | toFormGroup"></empathy-single-choice-question-view>
          }
          @case (questionType.MultiChoice) {
            <empathy-multi-choice-question-view
              [question]="question"
              [questionGrp]="questionCtrl | toFormGroup"
              (forceStop)="forceStop.emit($event)"
            ></empathy-multi-choice-question-view>
          }
          @case (questionType.Carousel) {
            <empathy-carousel-question-view [question]="question" [questionsGrp]="questionCtrl | toFormGroup"></empathy-carousel-question-view>
          }
          @case (questionType.CarouselMultiChoice) {
            <empathy-carousel-question-multi-choice-view
              [question]="question"
              [questionsGrp]="questionCtrl | toFormGroup"
              (forceStop)="forceStop.emit($event)"
            ></empathy-carousel-question-multi-choice-view>
          }
          @case (questionType.CarouselRating) {
            <empathy-carousel-rating-question-view [question]="question" [questionsGrp]="questionCtrl | toFormGroup"></empathy-carousel-rating-question-view>
          }
          @case (questionType.Essay) {
            <empathy-essay-question-view [question]="question" [questionCtrl]="questionCtrl | toFormControl"></empathy-essay-question-view>
          }
          @case (questionType.Heatmap) {
            <empathy-heatmap-question-view [question]="question" [questionCtrl]="questionCtrl | toFormControl"></empathy-heatmap-question-view>
          }
          @case (questionType.Input) {
            <empathy-input-question-view [question]="question" [questionCtrl]="questionCtrl | toFormControl"></empathy-input-question-view>
          }
          @case (questionType.Dropdown) {
            <empathy-dropdown-question-view [question]="question" [questionGrp]="questionCtrl | toFormGroup"></empathy-dropdown-question-view>
          }
          @case (questionType.Rating) {
            <empathy-rating-question-view [question]="question" [questionGrp]="questionCtrl | toFormGroup"></empathy-rating-question-view>
          }
          @case (questionType.FileUpload) {
            <empathy-file-upload-question-view [question]="question" [questionCtrl]="questionCtrl | toFormArray"></empathy-file-upload-question-view>
          }
          @case (questionType.AIChat) {
            <empathy-ai-chat-question-view
              [question]="question"
              [questionCtrl]="questionCtrl | toFormArray"
              (forceStop)="forceStop.emit($event)"
              (httpError)="httpError.emit()"
            ></empathy-ai-chat-question-view>
          }
          @case (questionType.NPS) {
            <empathy-nps-question-view [question]="question" [questionCtrl]="questionCtrl | toFormControl"></empathy-nps-question-view>
          }
          @case (questionType.Ranking) {
            <empathy-ranking-question-view [question]="question" [questionCtrl]="questionCtrl | toFormControl"></empathy-ranking-question-view>
          }
          @case (questionType.RankSort) {
            <empathy-rank-sort-question-view
              [question]="question"
              [questionCtrl]="questionCtrl | toFormGroup"
              (forceStop)="forceStop.emit($event)"
            ></empathy-rank-sort-question-view>
          }
          @default {
            <p>This question type does not have any screen configured or does not require it</p>
          }
        }
      </div>
    </empathy-viewer-template-card>
  </div>
}
